<template>
  <div class="product-area">
    <secBanner></secBanner>
    <el-container class="container content-area">
      <el-aside class="aside-area" width="260px">
        <ul>
          <li class="lead">产品展示</li>
          <li v-for="(item, index) in typeArr" :key="index">
            <router-link :to="{ path: '/productCenter', query: { typename: item.id } }" :class="curType.id === item.id ? 'cur' : ''">{{ item.name }}</router-link>
          </li>
        </ul>
      </el-aside>
      <div class="sub-content-area">
        <div class="breadcrumb-nav">
          您的位置：
          <!-- <router-link to="/" title="首页">首页</router-link>> -->
          <router-link to="/productCenter" title="产品展示">产品展示</router-link>
          <span v-if="this.$route.query.typename">&nbsp;>&nbsp;{{ curType.name }}</span>
        </div>
        <div class="product-list">
          <ul class="dis_flex flex_wrap">
            <li v-for="(item, index) in dataList" :key="index">
              <router-link :to="{ name: 'productDetail', params: { typeid: item.product_class_id, id: item.id } }">
                <div class="img"><img :src="item.product_img_pc[0]" :alt="item.product_name" /></div>
                <div class="text">
                  <div class="title ellipsis">{{ item.product_name }}</div>
                </div>
              </router-link>
            </li>
          </ul>
        </div>
        <pagination
          :total="total"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.limit"
          layout="total, prev, pager, next, jumper"
          :hide-on-single-page="total < listQuery.limit"
          @pagination="getList"
        />
      </div>
    </el-container>
  </div>
</template>
<script>
import Pagination from '@/components/assembly/pagination';
import secBanner from '@/components/assembly/sec-banner';
export default {
  data() {
    return {
      typeArr: [],
      curType: 0,
      dataList: [],
      total: 0,
      listQuery: {
        page: 1,
        limit: 9
      },
      routepath: this.$route.path,
      metaInfoAttr: {}
    };
  },
  metaInfo() {
    return {
      title: this.metaInfoAttr.title,
      meta: [
        {
          name: 'keywords',
          content: this.metaInfoAttr.keywords
        },
        {
          name: 'description',
          content: this.metaInfoAttr.description
        }
      ]
    };
  },
  watch: {
    $route(to, from) {
      if (this.$route.query.typename) {
        this.typeArr.forEach(element => {
          if (element.id === this.$route.query.typename) {
            this.curType = element;
          }
        });
        this.getList(this.$route.query.typename);
      } else {
        this.curType = {};
        this.getList();
      }
    }
  },
  mounted() {
    this.getType();
    // console.log(this.$route)
  },
  methods: {
    getType: function() {
      this.$https
        .fetchPost('/Product/product_class_list', {})
        .then(res => {
          // console.log(res.data, this.$route.query.typename)
          this.typeArr = res.data.data;
          // this.$router.push({ name: 'ProductCenter', query: { id: res.data.data[0].id } })
          if (this.$route.query.typename) {
            this.typeArr.forEach(element => {
              if (element.id === Number(this.$route.query.typename)) {
                // console.log(element.id, element.id === Number(this.$route.query.typename))
                this.curType = element;
              }
            });
          } else {
            // this.curType = res.data.data[0]
          }
          this.getList(this.curType.id ? this.curType.id : '');
        })
        .catch(err => {
          console.log(err);
        });
    },
    getList: function(typeid) {
      this.$https
        .fetchPost('/Product/product_info_list', {
          product_class_id: this.curType.id ? this.curType.id : '',
          page: this.listQuery.page,
          limit: this.listQuery.limit
        })
        .then(res => {
          // console.log(res.data)
          this.dataList = res.data.data;
          this.total = res.data.count;
          this.getSeo();
        })
        .catch(err => {
          console.log(err);
        });
    },
    getSeo() {
      this.$https
        .fetchPost('/api/getseo', {
          name: this.curType.name
        })
        .then(res => {
          this.metaInfoAttr = res.data.data;
        });
    },
    toDetail(id) {
      console.log(this.curType.id, id);
      // this.$router.push({ name: 'productDetail', params: { typeid: this.curType.id, id: id } })
    }
  },
  components: {
    secBanner,
    Pagination
  }
};
</script>
<style lang="less">
.product-area {
  .product-list {
    padding: 25px 0;
    li {
      width: 280px;
      background-color: #ffffff;
      box-shadow: 0px 0px 21px 0px rgba(12, 3, 6, 0.08);
      margin-bottom: 35px;
      &:not(:nth-child(3n)) {
        margin-right: 25px;
      }
      .img {
        width: 280px;
        height: 280px;
        overflow: hidden;
        background-color: #eeeeee;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .text {
        text-align: center;
        font-family: MicrosoftYaHei-Bold;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 32px;
        letter-spacing: 0px;
        color: #999999;
        padding: 10px 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ProductCenter.vue